import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { Base } from "ui/Scripts/source/framework/base";
import { IRecordUnit, RecordUnit } from "ui/Scripts/source/models/unit/recordUnit";
import { IMessageEditItemTargetCompanyGroup, MessageEditItemTargetCompanyGroup } from "./messageEditItemTargetCompanyGroup";

export interface IMessageEditItem extends IEditItem {
    companyId: string;
    unitId: string;
    messageTypeId: string;
    date: number;
    startDate: number;
    endDate: number;
    title: string;
    content: string;
    requiresReceipt: boolean;
    systemAdminMessage: boolean;
    targetUnits: IRecordUnit[];
    targetCompanyGroups: IMessageEditItemTargetCompanyGroup[];
    attachments: IFileAttachment[];
    lockedUser: IModifyUser;
    modifyUser: IModifyUser;
}

export class MessageEditItem extends EditItem implements IMessageEditItem {
    companyId: string;
    unitId: string;
    messageTypeId: string;
    date: number;
    startDate: number;
    endDate: number;
    title: string;
    content: string;
    requiresReceipt: boolean;
    systemAdminMessage: boolean;
    targetUnits: RecordUnit[];
    targetCompanyGroups: MessageEditItemTargetCompanyGroup[];
    attachments: IFileAttachment[];
    lockedUser: IModifyUser;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IMessageEditItem);
    constructor(obj?: any) {
        super(obj);
        this.companyId = obj && obj.companyId || "";
        this.unitId = obj && obj.unitId || "";
        this.messageTypeId = obj && obj.messageTypeId || "";
        this.date = obj && obj.date || 0;
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.title = obj && obj.title || "";
        this.content = obj && obj.content || "";
        this.requiresReceipt = obj && obj.requiresReceipt || false;
        this.systemAdminMessage = obj && obj.systemAdminMessage || false;
        this.targetUnits = Base.getTypedArray(obj ? obj.targetUnits : null, RecordUnit);
        this.targetCompanyGroups = Base.getTypedArray(obj ? obj.targetCompanyGroups : null, MessageEditItemTargetCompanyGroup);
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
        this.lockedUser = new ModifyUser(obj ? obj.lockedUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }

    isLockedToOtherUser(userCode: string): boolean {
        return this.lockedUser?.code ? !userCode.equalIgnoreCase(this.lockedUser.code) : false;
    }
}